<template>
	<Modal
		:title="title"
		:type="type"
		:confirmText="confirmText"
		:cancelText="cancelText"
		@close="$emit('close')"
		@confirm="$emit('confirm')"
	>
		<div v-html="message"></div>
	</Modal>
</template>
<script>
import Modal from '~/components/ui/layout/Modal'

export default {
	components: {
		Modal
	},
	props: ['title', 'message', 'type', 'confirmText', 'cancelText']
}
</script>
